import { useMutation } from '@gogame/query';

import { createTag } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/tags';

import { tagsCreate, tagsGrid } from '../queryKeyFactory';

export const useCreateTag = () => {
  const createMutation = useMutation(tagsCreate(), createTag, {
    successMessage: () => 'Tag created',
    refreshOptions: {
      queryKey: tagsGrid(),
    },
  });

  return [createMutation.mutateAsync, createMutation];
};
